// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sections-container[data-v-7a19ad5c]{display:flex;flex-direction:row;flex-wrap:wrap;align-content:flex-start;justify-content:space-between;align-items:flex-start}\n", ""]);
// Exports
module.exports = exports;
